import React from 'react';
import { motion } from 'framer-motion';
export function BureauTrustSection() {
  const bureaus = [{
    name: 'Equifax',
    id: 'equifax'
  }, {
    name: 'Experian',
    id: 'experian'
  }, {
    name: 'TransUnion',
    id: 'transunion'
  }, {
    name: 'Innovis',
    id: 'innovis'
  }];
  return <section className="py-16 bg-[#f5f5f7] border-y border-gray-200" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="text-center mb-8" data-id="element-18">
          <h3 className="text-sm font-bold tracking-widest text-slate uppercase" data-id="element-19">
            We track tools that report to:
          </h3>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-20">
          {bureaus.map((bureau, index) => <motion.div key={bureau.id} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white py-6 px-4 rounded-xl border border-gray-200 shadow-sm flex items-center justify-center" data-id="element-21">
              <span className="font-extrabold text-xl text-navy tracking-tight" data-id="element-22">
                {bureau.name}
              </span>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-23">
          <p className="text-slate font-medium" data-id="element-24">
            Tools reporting to MORE bureaus build credit faster. Look for the{' '}
            <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-bold bg-emerald text-white mx-1" data-id="element-25">
              Best Match
            </span>{' '}
            badge above.
          </p>
        </div>
      </div>
    </section>;
}